<script lang="ts">
    import Avatar from "$lib/components/Avatar.svelte";
    import CustomerAvatar from "$lib/components/CustomerAvatar.svelte";
    import type {Customer} from "$lib/types/user";

    export let customer: Customer;
</script>
<div class="items-center bg-gray-50 rounded-lg shadow sm:flex dark:bg-gray-700 dark:border-gray-700">

    <div class="p-5">
        <div class="flex gap-3">
            <CustomerAvatar size="lg" {customer}/>
            <div>
                <h3 class="text-xl font-bold tracking-tight text-neutral-700 dark:text-white">
                    <a href={'/client/' + customer.uuid}>{customer.name}</a>
                </h3>
                <span class="text-gray-500 dark:text-gray-400">KnNr {customer.registry}</span>
            </div>
        </div>

        <ul class="divide-y divide-gray-100">

            <li class="flex gap-x-4 py-5">
                <div class="w-24 text-neutral-600 dark:text-gray-400">
                    Kontakt
                </div>
                <div class="min-w-0">
                    <p class="mt-1 truncate text-xs leading-5 text-gray-500 flex gap-3">
                        <svg class="-ml-0.5 mr-1.5 h-5 w-5 text-gray-400" viewBox="0 0 20 20"
                             fill="currentColor" aria-hidden="true">
                            <path d="M3 4a2 2 0 00-2 2v1.161l8.441 4.221a1.25 1.25 0 001.118 0L19 7.162V6a2 2 0 00-2-2H3z"/>
                            <path d="M19 8.839l-7.77 3.885a2.75 2.75 0 01-2.46 0L1 8.839V14a2 2 0 002 2h14a2 2 0 002-2V8.839z"/>
                        </svg>
                        <span>{customer.email ?? '-'}</span>
                    </p>
                    <p class="mt-1 truncate text-xs leading-5 text-gray-500 flex gap-3">
                        <svg class="-ml-0.5 mr-1.5 h-5 w-5 text-gray-400" viewBox="0 0 20 20"
                             fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd"
                                  d="M2 3.5A1.5 1.5 0 013.5 2h1.148a1.5 1.5 0 011.465 1.175l.716 3.223a1.5 1.5 0 01-1.052 1.767l-.933.267c-.41.117-.643.555-.48.95a11.542 11.542 0 006.254 6.254c.395.163.833-.07.95-.48l.267-.933a1.5 1.5 0 011.767-1.052l3.223.716A1.5 1.5 0 0118 15.352V16.5a1.5 1.5 0 01-1.5 1.5H15c-1.149 0-2.263-.15-3.326-.43A13.022 13.022 0 012.43 8.326 13.019 13.019 0 012 5V3.5z"
                                  clip-rule="evenodd"/>
                        </svg>
                        <span>{customer.phone}</span>
                    </p>
                </div>
            </li>
            <li class="flex gap-x-4 py-5">
                <div class="w-24 text-neutral-600 dark:text-gray-400">
                    Team
                </div>
                <div class="min-w-0">
                    <div class="isolate flex -space-x-1">
                        {#each customer.associates as associate, index}
                            {#if index < 3}
                                <Avatar size="md" {associate}/>
                            {/if}
                        {/each}
                        {#if customer.associates.length > 2}
                            <div class="pl-2">
                                <svg title="weitere.." class="w-5 h-5 mt-3" fill="none"
                                     stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"
                                     xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                          d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"></path>
                                </svg>
                            </div>

                        {/if}
                    </div>
                </div>
            </li>

        </ul>
    </div>
</div>
